import { createApp } from 'vue'

// Select the App you want to run on main, each individual are on /appName/App.vue
import App from './OnBoardingQuestionsAndAnswers.vue'
// import library styles
import '../../../styles/tailwind.css'

// import custom styles
import '../../../styles/main_direct.scss'



const estimateApp = createApp(App, {
    isEstimate: true,
});
estimateApp.mount("#vue-estimate-faq");

const signupApp = createApp(App, {
    isEstimate: false,
});
signupApp.mount("#vue-signup-faq");
